import { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    ModalButton,
    SelectionFixedFooter,
    TableBody,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { ProbeStock, ProbeStockSearchForm } from 'entities/probe_stock'
import { useFetchProbeStocksApi } from 'api/probe_stock'
import { probeStockColumnInfoList, ProbeStockTableData } from './probe_stock_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useForm, useQuery } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditProbeStockForm } from './probe_stock_form'
import { useState } from 'react'
import { SearchConditionView } from 'components/shared/search_drawer'
import { Button } from 'react-bootstrap'
import { InputField } from 'components/shared/input'
import { downloadFile } from 'utils/util'
import moment from 'moment'

type Props = {
    history: H.History
}

const ProbeStocksPage = (props: Props) => {
    const query = useQuery<ProbeStockSearchForm>()
    const searchForm = useForm<ProbeStockSearchForm>({ ...query })
    const listApi = useFetchProbeStocksApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const probeStockDisplaySetting = useDisplaySetting(probeStockColumnInfoList(searchForm), 'ProbeStock')
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedProbeStock, setSelectedProbeStock] = useState<ProbeStock>({})
    const multipleCheckForm = useMultipleCheckForm()
    const csvOutputForm = useForm<{ amount: number }>({ amount: 1 })

    useEffect(() => {
        listApi.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof ProbeStockSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <EditProbeStockForm
                show={showEdit}
                probeStock={selectedProbeStock}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle="Probeロット・在庫"
                left={
                    <>
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <thead>
                            <CheckboxTableRow head allCheck allItems={listApi.response.results} multipleCheckForm={multipleCheckForm}>
                                <ActionTableCell th></ActionTableCell>
                                <TableHeads displaySetting={probeStockDisplaySetting} />
                            </CheckboxTableRow>
                        </thead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((probeStock: ProbeStock) => {
                                return (
                                    <CheckboxTableRow key={`probeStock-${probeStock.id}`} item={probeStock} multipleCheckForm={multipleCheckForm}>
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedProbeStock(probeStock)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <ProbeStockTableData probeStock={probeStock} displaySetting={probeStockDisplaySetting} />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="Extraction"
            >
                <ModalButton
                    openButton={<Button>分注ラベルCSV出力</Button>}
                    modalHeader={<>分注ラベルCSV出力</>}
                    modalBody={
                        <>
                            <InputField form={csvOutputForm} attr="amount" label="分注数を入力してください" type="number" min={0} max={100} />
                        </>
                    }
                    submitButton={
                        <Button
                            onClick={() => {
                                const lines: string[] = ['Probe,Lot number,Tube ID,枝番']
                                multipleCheckForm.form.object.items.map((item) => {
                                    const ps: ProbeStock = item as ProbeStock
                                    for (let i = 0; i < csvOutputForm.object.amount; i++) {
                                        lines.push(`${ps.probeName},${ps.lotNumber},${ps.vialId},${i + 1}`)
                                    }
                                })
                                const csv = lines.join('\n')
                                downloadFile(csv, `dispensed_probes_${moment().format('YYYYMMDDhhmm')}.csv`, 'text/csv')
                            }}
                        >
                            CSV出力
                        </Button>
                    }
                />
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(ProbeStocksPage)
